export const ReservationRequestType = [
    {
        value: 0,
        label:"ثبت کار سفارشی"
    },
    {
        value: 1,
        label:"ثبت اندازه گیری"
    },

]